var map = {
	"./de-DE/txt_voted-share.png": "3883",
	"./en-GB/txt_voted-share.png": "d799",
	"./en-US/txt_voted-share.png": "18ca",
	"./es-ES/txt_voted-share.png": "a0cd",
	"./es-MX/txt_voted-share.png": "e4bc",
	"./fr-CA/txt_voted-share.png": "9255",
	"./fr-FR/txt_voted-share.png": "cb0f",
	"./it-IT/txt_voted-share.png": "380e",
	"./ja-JP/txt_voted-share.png": "d98d",
	"./pt-BR/txt_voted-share.png": "538a",
	"./zh-TW/txt_voted-share.png": "061e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba44";